module.exports = __webpack_public_path__ + "static/media/company_group.86a0b8af.svg";